import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const TrendArrowDownIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M17 14V24H7L7.02994 22.2036L13.991 22.2186L6.38623 14.61377L7.61377 13.38623L15.2186 20.991L15.2335 14L17 14Z'
                fill='currentColor'
            />
        </>
    ),
})

TrendArrowDownIcon.displayName = 'TrendArrowDownIcon'
